export enum eSize {
    large = "large",
    medium = "medium",
    smalll = "smalll"
}